var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"link":"","to":_vm.option.link}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.option.icon))])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.option.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }